// userService.js
import { get, post, put, patch } from './common';


export const createReport = (data) => {
    return post('report', data, { "content-type": "multipart/form-data"});
}

export const updateReport = (reportId, data) => {
  return put('report/'+reportId, data, { "content-type": "multipart/form-data"});
}

export const getReportById = (reportId) => {
  return get('report/'+reportId);
}

export const deleteReportById = (reportId) => {
  return post('report/remove',{"reportIDs": reportId});
}

export const shareReportById = (reportId, data) => {
  return post('report/share/'+reportId,data);
}

export const transferReportById = (reportId, userID) => {
  return patch('report/transfer/'+reportId+'/'+userID);
}

export const getReports = (filterData ) => {
  return get('report', filterData);
};
